import React, {memo, useEffect, useState, useRef} from 'react';
import {Box, Paper} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {productAction} from "../../actions";
import {connect, useSelector} from "react-redux";
import Button from "@mui/material/Button";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {TagAutocomplete} from "../index";
import Chip from "@mui/material/Chip";
import {Loading} from './../../components'
import SunEditor, {buttonList} from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import Switch from "@mui/material/Switch";
import FormControlLabel from '@mui/material/FormControlLabel';
import CustomizedTables from "../table/table";
import SelectProduct from "../selectProducts/selectProduct";
import LandingPageCreate from "../landingPage/create";

const EditSeo = memo((props) => {

    const {contentID, onComplete, authReducer} = props;

    const [form, setForm] = useState({});
    const [editorData, setEditorData] = useState({});
    const [loading, setLoading] = useState(true);
    const [tag, setTag] = useState([]);
    const [headTitle, setHeadTitle] = useState("");
    const [headKey, setHeadKey] = useState("");
    const [headList, setHeadList] = useState([]);
    const [checked, setChecked] = useState(true);
    const [landingPageData, setLandingPageSata] = useState([]);
    const productReducer = useSelector((state) => state.productReducer)

    const text = useRef()

    const editor = useRef();

    // The sunEditor parameter will be set to the core suneditor instance when this function is called
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };


    useEffect( () => {
        new Api().get('/blog/' + contentID + '/seo', {}, false).then((response) => {
            if (typeof response !== "undefined") {

                let init_tags = [];
                if (response.tags) {
                    response.tags.map((t) => {
                        init_tags.push(t.id);
                    });
                }

                setTag(init_tags);
                let arr = []

                for(let i = 0 ; i < response.items.length  ; i++) {
                    if(response.items?.[i]?.itemable && !response.items?.[i]?.itemable?.products) {
                        arr.push({content:response.items?.[i]?.itemable?.content , id:response.items?.[i]?.id , item_id:response.items?.[i]?.id ,type: "text",title:response.items?.[i]?.itemable?.title})
                    } else if(response.items?.[i]?.itemable && response.items?.[i]?.itemable?.products) {
                        arr.push({products:response.items?.[i]?.itemable?.products , id:response.items?.[i]?.id ,type: "product",title:response.items?.[i]?.itemable?.title})
                    }
                }
                let obj = {...response }
                obj.items = arr

                setForm(obj);


            }

            setLoading(false);
        })
    }, []);

    useEffect(() => {
        handleContent()

        setChecked(true)

        if (form?.h2_titles?.[0]?.title) {
            if (form?.h2_titles) {
                setHeadList(form?.h2_titles)
            }
        } else {
            handleContent()
        }
    }, [form.content, form?.h2_titles])


    const cleanText = () => {
        if(text?.current) {
            let n_form = form;
            n_form['content'] = text?.current?.innerText;
            setForm({...n_form});
        }
    }




    const handleContent = () => {
        let htmlCode = form?.content?.replace(/<\s*([a-z][a-z0-9]*)\s.*?>/gi, '<$1>')
        let htmlCodeConcat
        for(let i in form.items) {
            if(form.items[i]?.itemable?.content) {
                htmlCodeConcat = htmlCode.concat(form.items[i]?.itemable?.content)
            }
        }

        let content = htmlCodeConcat?.match(/<h2>(.*?)<\/h2>/g)?.map(function (val) {
            return val.replace(/<\/?h2>/g, '');
        });
        let arr = []
        for (let i in content) {
            arr.push({title: content[i], value: content[i]})
        }
        setHeadList(arr)
    }


    const handleChangeElement = (event) => {

        let frm = form;
        frm[event.target.name] = event.target.value;
        setForm({...frm});
    };

    const onDelete = (e) => {
        let arr = [...headList]
        arr.splice(e, 1)
        setHeadList(arr)
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        let arr = []
        await form["products"]?.forEach((item) => {
            arr.push(item?.id)
        })
        form["products"] = arr

        setLoading(true);

        let n_form = {...form};
        n_form['tags'] = tag;
        n_form['form'] = "blog_seo_update";
        n_form['items'] = {...landingPageData};
        if (checked) {
            n_form['h2_titles'] = headList;
        } else {
            n_form['h2_titles'] = [false];
        }

        new Api().put('/blog/' + contentID + '/seo', n_form, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    if (typeof onComplete !== undefined) {
                        onComplete();
                    }
                    toast.success(response.msg);
                } else {
                    toast.error(response.msg);
                }

                setLoading(false);
            }
        })

    };

    const handleHeading = () => {
        setHeadList([...headList, {title: headTitle, value: headKey}])
        setHeadKey("")
        setHeadTitle("")
    }



    return (
        <form onSubmit={handleSubmit} className='animate__animated animate__fadeIn'>
            <Box mt={5}>
                <Box mt={5}>
                    <Paper style={{padding: '25px'}}>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextField
                                    label="اسلاگ"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.slug}
                                    fullWidth
                                    name='slug'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    helperText='بدون فاصله وارد کنید.'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="متا عنوان"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.meta_title}
                                    fullWidth
                                    name='meta_title'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    helperText='60 تا 255 کاراکتر وارد کنید.'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="متا توضیحات"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.meta_description}
                                    fullWidth
                                    name='meta_description'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    helperText='60 تا 255 کاراکتر وارد کنید.'
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>
                <Box mt={5}>
                    <Paper style={{padding: '25px'}}>
                        <Grid container>
                            <FormControlLabel
                                style={{margin: "0 0 20px 0"}}
                                value="top"
                                control={<Switch
                                    checked={checked}
                                    onChange={() => {
                                        setChecked(!checked);
                                        handleContent()
                                    }}
                                    inputProps={{'aria-label': 'controlled'}}
                                    color="primary"/>}
                                label="فهرست مطالب"
                                labelPlacement="right"
                            />
                            {
                                (!form?.h2_titles || form?.h2_titles === []) && "( لیست جهت نمایش فعال نشده است )"
                            }
                            {
                                checked &&
                                <Grid  alignItems={"center"} container xs={12}>
                                    <Grid item xs={5}>
                                        <TextField
                                            label="تایتل"
                                            variant="outlined"
                                            margin='dense'
                                            value={headTitle}
                                            fullWidth
                                            name='headTitle'
                                            onChange={(e) => setHeadTitle(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            helperText={'عنوان قابل نمایش '}
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <TextField
                                            disabled={!headTitle}
                                            label="کلمه کلیدی"
                                            variant="outlined"
                                            margin='dense'
                                            value={headKey}
                                            fullWidth
                                            name='headKey'
                                            onChange={(e) => setHeadKey(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            helperText={'متنی که درون h2 قرار دارد '}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Button style={{marginTop: "-20px"}} disabled={!headTitle || !headKey}
                                                onClick={(e) => {
                                                    handleHeading(e)
                                                }} variant='contained' color='primary'> افزودن</Button>
                                    </Grid>

                                    <CustomizedTables data={headList} onDelete={(e) => {
                                        onDelete(e)
                                    }}
                                    />

                                </Grid>
                            }
                            <Grid item xs={12}>
                                <div style={{margin: "30px 0 10px 0"}}>توضیحات کوتاه</div>
                                {
                                    form.content !== undefined &&
                                    <SunEditor
                                        setOptions={{
                                            height: 200,
                                            buttonList: buttonList.complex
                                        }}
                                        value={form["short_content"]}
                                        height="100px"
                                        getSunEditorInstance={getSunEditorInstance}
                                        defaultValue={form.short_content}
                                        onChange={(value) => {
                                            let frm = form;
                                            frm['short_content'] = value;
                                            setForm({...frm});
                                        }}/>
                                }
                            </Grid>
                            {
                                form.content !== undefined && form.content &&
                                <Grid item xs={12} style={{margin: '20px 0'}}>
                                    <div style={{margin: "30px 0 10px 0"}}>توضیحات</div>
                                    {
                                        <SunEditor
                                            setOptions={{
                                                buttonList: buttonList.complex
                                            }}
                                            value={form["content"]}
                                            height="600px"
                                            getSunEditorInstance={getSunEditorInstance}
                                            defaultValue={form["content"]}
                                            onChange={(value) => {
                                                cleanText()
                                                handleContent()
                                                let n_form = editorData;
                                                n_form['content'] = value;
                                                setEditorData({...n_form});
                                            }}/>
                                    }
                                </Grid>

                            }
                            <Grid item xs={12}>
                                <div style={{margin: "30px 0 10px 0"}}>
                                    <TagAutocomplete onChange={(value) => {
                                        let tags = tag;
                                        value.forEach((value) => {
                                            tags.push(value.id);
                                        });
                                        setTag(tags);
                                    }}/>
                                    {form.tags && form.tags.map((item, index) => {
                                        return (
                                            <Chip
                                                label={item.name}
                                                clickable
                                                color="default"
                                                onDelete={() => {
                                                    // remove from form
                                                    let tags = form['tags'];
                                                    tags.splice(index, 1);
                                                    form['tags'] = tags;
                                                    // remove from tag
                                                    tags = tag;
                                                    tags.splice(index, 1);
                                                    // init tag in form and tag const
                                                    setForm({...form});
                                                    setTag(tags);
                                                }}
                                            />
                                        )
                                    })}
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Box mt={5}>
                        <Paper style={{padding: '25px'}}>
                        <Grid xs={12} item  style={{margin: '20px 0'}}>
                            <LandingPageCreate landingPageData={form.items} onChange={(e) => setLandingPageSata(e)}/>
                        </Grid>



                        {
                            form?.products?.length > 0 &&
                            <div style={{margin: "30px 0 10px 0"}}>

                                <SelectProduct title={"محصولات مرتبط"} list={productReducer} state={"products"}
                                               formData={form}
                                               onchange={(items) => form.products = items.products}/>
                            </div>
                        }
                    </Paper>
                    </Box>
                </Box>
            </Box>
            <Box mt={2} className='display-flex display-flex-direction-row display-flex-justify-content-flex-end'>
                <Button disabled={loading} variant='contained' color='primary' type="submit">تکمیل اطلاعات</Button>
            </Box>
            {loading && <Loading/>}
        </form>
    );
})


const mapStateToProps = state => ({
    authReducer: state.authReducer,
    productReducer: state.productReducer,

});

const mapDispatchToProps = (dispatch) => ({
    fetchProducts: (object) => {
        dispatch(productAction.fetchProducts(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSeo)









